import request from '@/api/request.js'

// 新增
export function UserVSPaperInsert(data) {
    return request({
        url: '/api/user/uservspaperinsert',
        method: 'post',
        data: data
    })
}

// 新增
export function UserVSPaperInsertMany(data) {
    return request({
        url: '/api/user/uservspaperinsertmany',
        method: 'post',
        data: data
    })
}

// 删除
export function UserVSPaperDelete(id) {
    return request({
        url: `/api/user/uservspaperdelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function UserVSPaperUpdate(id, data) {
    return request({
        url: `/api/user/uservspaperupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 更新
export function UserVSPaperUpdateMany(data) {
    return request({
        url: '/api/user/uservspaperupdatemany',
        method: 'post',
        data: data
    })
}

// 获取
export function UserVSPaperGetById(id) {
    return request({
        url: `/api/user/getuservspaperbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function UserVSPaperGetList(params) {
    return request({
        url: '/api/user/getuservspaperlist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function UserVSPaperGetPageList(params) {
    return request({
        url: '/api/user/getuservspaperpagelist',
        method: 'get',
        params: params
    })
}